module.exports = __webpack_public_path__ + "static/media/investorGivesStudentMoney.c8f06338.png";